import { PureComponent } from "react";

import autobind from "autobind-decorator";
import { connect } from "react-redux";

import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

import { AllContexts } from "pro-features/pages/Leading Folders/src/AllContexts";
import { LeadingFoldersInfoPanelInProgress } from "pro-features/pages/Leading Folders/src/LeadingFoldersInProgressInfoPanel";
import { LeadingFoldersSuccessInfoPanel } from "pro-features/pages/Leading Folders/src/LeadingFoldersSuccessInfoPanel";
import UIComponentStateService from "../../../../../services/UIComponentStateService";

interface ILeadingFoldersPanelInfoContainer {
    leadingFolderPage?: any;
}

const STATUS = {
    GotIt: "done",
    InProgress: "inProgress",
};

class LeadingFoldersPanelInfoContainer extends PureComponent<ILeadingFoldersPanelInfoContainer, any> {
    public i18n: any;

    public uiComponentState: any;

    public swNavigator: any;

    constructor(props) {
        super(props);
        this.i18n = i18nFilter();
        this.swNavigator = proNavigator;
        this.uiComponentState = UIComponentStateService;
        this.state = {
            loading: true,
            isFolderAnalysisSupported: false,
            mainSite: this.swNavigator.getParams().key,
        };
    }

    public componentDidUpdate() {
        if (this.props.leadingFolderPage.leadingFolderHeader) {
            const leadingFolderHeader = this.props.leadingFolderPage.leadingFolderHeader;
            this.setState({
                loading: false,
                isFolderAnalysisSupported:
                    leadingFolderHeader.IsFolderAnalysisSupported &&
                    leadingFolderHeader.IsFolderAnalysisSupported[leadingFolderHeader.MainSite],
                mainSite: leadingFolderHeader.MainSite,
            });
        } else {
            this.setState({
                loading: true,
                isFolderAnalysisSupported: false,
                mainSite: this.swNavigator.getParams().key,
            });
        }
    }

    @autobind
    private getSavedKeyStatus(domain) {
        return this.uiComponentState.getItem(domain || this.state.mainSite, "localStorage", true);
    }

    @autobind
    private setKeyStatus(status) {
        this.uiComponentState.setItem(this.state.mainSite, "localStorage", status, true);
    }

    @autobind
    public setKeyStatusInprogress() {
        this.setState({
            ...this.state,
            status: STATUS.InProgress,
        });
        return this.setKeyStatus(STATUS.InProgress);
    }

    @autobind
    public setKeyStatusGotIt() {
        this.setState({
            ...this.state,
            status: STATUS.GotIt,
        });
        return this.setKeyStatus(STATUS.GotIt);
    }

    public render() {
        const { isFolderAnalysisSupported, mainSite, loading } = this.state;
        const status = this.getSavedKeyStatus(mainSite);
        return loading ? (
            <div />
        ) : (
            <div style={{ marginBottom: "24px" }}>
                <AllContexts
                    translate={this.i18n}
                    track={allTrackers.trackEvent.bind(allTrackers)}
                >
                    {status === STATUS.InProgress && !isFolderAnalysisSupported ? (
                        <LeadingFoldersInfoPanelInProgress />
                    ) : null}
                    {status !== STATUS.GotIt && isFolderAnalysisSupported ? (
                        <LeadingFoldersSuccessInfoPanel
                            domain={mainSite}
                            gotItButtonClick={this.setKeyStatusGotIt}
                        />
                    ) : null}
                </AllContexts>
            </div>
        );
    }
}

function mapStateToProps(store) {
    const leadingFolderPage = store.leadingFolderPage;
    return {
        leadingFolderPage,
    };
}

export default connect(mapStateToProps, null)(LeadingFoldersPanelInfoContainer);
